import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/partner/page.jsx");
